import "./footer.css";
import legalPDF from '../../../assets/documents/DEV4 Website T&C 18 July 2023.pdf';
import privacyPolicyPDF from '../../../assets/documents/DEV4 Privacy Policy 18 July 2023.pdf';

export default function Footer() {
 const currentYear = new Date().getFullYear()
 return (
  <footer>
   <div className="footer-legal-container footer-text">
    <p className="fs-md mb-0"><span>© {currentYear}. All rights reserved. Property of DEV4 Online LTD.</span></p>

    DEV4 Online LTD.<br />
    <a target="_blank" rel="noreferrer" href={privacyPolicyPDF} className="info-link">Privacy Policy</a>
    <br />
    <a target="_blank" rel="noreferrer" href={legalPDF} className="info-link">Legal</a>

    <br /><br />
    This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" className="info-link">Privacy Policy</a> and <a href="https://policies.google.com/terms" className="info-link">Terms of Service</a> apply.
   </div>
   <div>
    <iframe class="cyber-cert" src="https://registry.blockmarktech.com/certificates/42ef6744-a420-4590-91f6-0422e29f5154/widget/?tooltip_position=above&theme=transparent" title="Cyber Essentials Certification Badge"
     role="img"
     aria-label="Cyber Essentials Certification Badge"
     loading="lazy"></iframe>
   </div>

   <div >
    <ul class="social-links">
     <li>
      <a className="icon-circle-btn" target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/dev4-online/">
       <i className="ai-linkedin"></i>
      </a>
     </li>

     <li>
      <a className="icon-circle-btn" target="_blank" rel="noreferrer" href="https://www.facebook.com/dev4.online/">
       <i className="ai-facebook"></i>
      </a>
     </li>

     <li> <a className="icon-circle-btn" target="_blank" rel="noreferrer" href="https://www.youtube.com/@dev4online971">
      <i className="ai-youtube"></i>
     </a></li>
    </ul>
   </div>
  </footer>
 )
}